"use client";

import { ChevronRightCircle } from "lucide-react";

import { JetSmartButton } from "@repo/ui/components/common/forms/JetSmartButton";

import { CommonDialog } from "./CommonDialog";

interface InsuranceCultureChangeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
  continueText?: string;
  cancelText?: string;
}

export function InsuranceCultureChangeModal({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title = "Importante",
  description = "Si cambias de país se eliminará el seguro de tu cotización. ¿Estás seguro de que quieres continuar?",
  continueText = "Continuar",
  cancelText = "No, gracias",
}: Readonly<InsuranceCultureChangeModalProps>) {
  return (
    <CommonDialog
      open={open}
      onOpenChange={onOpenChange}
      contentClassName="p-0 overflow-hidden md:max-w-lg gap-0"
      closeOnOverlayClick
      closeOnEsc
      showCloseButton={false}
      title={
        <div className="bg-brand-red w-full p-4 flex items-center justify-center">
          <span className="text-xl font-bold text-white">{title}</span>
        </div>
      }
      titleClassName="p-0 m-0 w-full"
      headerClassName="p-0 space-y-0"
      footerClassName="hidden"
    >
      <div className="flex flex-col items-center justify-center p-6 space-y-6 text-center">
        <div className="text-brand-black text-md font-medium font-lato max-w-[90%] text-brand-blue-10">
          {description}
        </div>

        <JetSmartButton
          className="bg-brand-red hover:bg-brand-red/90 text-white rounded-full px-8 py-2 text-lg w-60"
          onClick={onConfirm}
          icon={<ChevronRightCircle className="w-6 h-6 ml-2 mt-1" />}
          iconPosition="right"
        >
          {continueText}
        </JetSmartButton>

        <button
          onClick={onCancel}
          className="underline text-md font-medium hover:text-brand-blue/80 text-brand-blue-10 hover:cursor-pointer"
        >
          {cancelText}
        </button>
      </div>
    </CommonDialog>
  );
}

export default InsuranceCultureChangeModal;
